// Module
var code = "<div class=\"block-1__image image\"></div> ";
// Exports
export default code;